/**
 * Setting auto-height and scroll for viscom iframes.
 */
Drupal.behaviors.toybox_iframe_salary_viscom = {
  // eslint-disable-next-line no-unused-vars
  attach: function () {
    window.addEventListener("message", function (e) {
      if (!e.data) {
        return;
      }

      // Setting iframe height.
      if (e.data.event_id === "vas-height") {
        const iframe = document.querySelector(
          'iframe[src*="//' + e.data.data.source + '"]',
        );

        if (!iframe) {
          return;
        }

        iframe.setAttribute("height", e.data.data.height);
      }

      // Scroll to iframe.
      if (e.data.event_id === "vas-scroll") {
        const scrollTarget = document.getElementById(e.data.data.scroll);
        const scrollOffset = e.data.data.offset;

        if (!scrollTarget) {
          return;
        }

        window.scrollTo({
          top: scrollTarget.offsetTop + scrollOffset,
          left: 0,
          behavior: "smooth",
        });
      }
    });
  },
};
